import { VisualSeoEffortImpact } from "../types";

export function getColorByScore(score: number) {
    if (score < 50) return '#f63842';
    if (score >= 50 && score < 80) return '#ffab00';
    return '#34bc6e';
}

// Impact: higher is better → HIGH green, MEDIUM amber, LOW grey (default tag).
export function getImpactTagColor(impact: VisualSeoEffortImpact): string | undefined {
    switch (impact) {
        case 'HIGH':
            return 'green';
        case 'MEDIUM':
            return 'orange';
        default:
            return undefined;
    }
}

// Effort: lower is better → inverse of impact. LOW green, MEDIUM amber, HIGH red.
export function getEffortTagColor(effort: VisualSeoEffortImpact): string | undefined {
    switch (effort) {
        case 'LOW':
            return 'green';
        case 'MEDIUM':
            return 'orange';
        default:
            return 'red';
    }
}
